import React from "react";
import moment from "moment";
import {Typography} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {useGetNBAPlayerSeasonStatsByPlayerIdQuery} from "../../../stores/tradefan/tradefan.api";

import "../SeasonStats.style.scss";
const NBASeasonStats = ({playerId, seasonYears}) => {
    const {data} = useGetNBAPlayerSeasonStatsByPlayerIdQuery({playerId, seasonYear: seasonYears[0]});

    return <div className="NBASeasonStats">
        <Typography variant="h6" className="gameLogTitle">
            {seasonYears[0]} - {seasonYears[1]} <FormattedMessage id={"popUp.contestPreview.seasonStats"}/>
        </Typography>
        <div className="seasonStats">
            <div className="statItem">
                <div>{data.GamesPlayed}</div>
                <div>GP</div>
            </div>
            <div className="statItem">
                <div>{data.Points}</div>
                <div>PTS</div>
            </div>
            <div className="statItem">
                <div>{data.Rebounds}</div>
                <div>REB</div>
            </div>
            <div className="statItem">
                <div>{data.Assists}</div>
                <div>AST</div>
            </div>
            <div className="statItem">
                <div>{data.FieldGoalsPercentage}</div>
                <div>FG%</div>
            </div>
            <div className="statItem">
                <div>{data.TotalPointsDeliveredPG}</div>
                <div>TPD/GM</div>
            </div>
        </div>
    </div>
}

export default NBASeasonStats;